import Service, { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

export default class StringsService extends Service {
  @service
  options;

  getProgressStrings(school) {
    let strings = {
      wellAbove: 'well above',
      above: 'above',
      at: 'at',
      below: 'below',
      wellBelow: 'well below',
    };

    Object.keys(strings).forEach((key) => {
      let value = this.options.schoolGet(school, `progress:strings:${key}`);
      if (!isEmpty(value)) {
        strings[key] = value;
      }
    });

    return strings;
  }
}
